import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { MobileApi } from "@freightsimple/generated-dashboard-openapi-client/apis/MobileApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useMobileApi(): MobileApi {
  const { accessToken } = useAuthentication();

  return new MobileApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
